import { Component, HostListener, OnInit } from '@angular/core';
import { SharedService } from 'src/app/shared.service';
import { Router } from '@angular/router'
import swal from 'sweetalert';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss']
})
export class EmployeeComponent implements OnInit {

  employeeList: any = [];

  ModalTitle: any;
  ActivateAddEditEmp: boolean = false;
  emp: any;

  dtElement!: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  constructor(private service: SharedService, private router: Router) { }


  // @HostListener('input') oninput()
  // {
  //   this.SearchItems();
  // }

  ngOnInit(): void
  {
    this.dtOptions =
    {
      pagingType: 'full_numbers',
      pageLength: 50
    };
    this.RefreshEmpList();
  }


  Test()
  {

  }


  RefreshEmpList()
  {
    this.service.GetEmpList().subscribe(data =>
    {
      this.employeeList = data;
    })

  }


  AddClick() {
    this.emp =
    {
      pkEmpId: 0
    }
    this.ModalTitle = "Enter New Employee Details";
    this.ActivateAddEditEmp = true;
  }


  EditClick(item: any) {
    this.emp = item;
    this.ModalTitle = "Edit Employee Details";
    this.ActivateAddEditEmp = true;
  }


  CloseClick() {
    this.ActivateAddEditEmp = false;
    this.RefreshEmpList();
  }


  DeleteClick(item: any)
  {
    swal(
    {
      title: "Are you sure?",
      text: "Once deleted, you might not be able to revert this.",
      icon: "warning",
      buttons: ["Cancel", "Ok"],
      dangerMode: true,
    })
      .then((willDelete) =>
      {
        if (willDelete)
        {
          this.service.DeleteEmployee(item.pkEmpId).subscribe(data =>
            {
            swal(data.toString(),
            {
              icon: "success",
            });
            this.RefreshEmpList();
          });
        }
      });
  }

  ViewAttendance(item: number) {
    this.service.ChangeEmpId(item);
    this.router.navigate(['/attendance-view'])
  }
}
